export default __webpack_public_path__ + "static/9_26-eadd72f4d9179e53c61fc709c30b29e7.png";